/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{lowercaseSVGElements as e}from"../../svg/lowercase-elements.js";function t(t){return"string"==typeof t&&!t.includes("-")&&!!(e.indexOf(t)>-1||/[A-Z]/.test(t))}export{t as isSVGComponent};
//# sourceMappingURL=is-svg-component.js.map
